export default "__VITE_ASSET__99a167c6__"